<!-- <ottimizza-quill></ottimizza-quill> -->
<app-date></app-date>
<app-snow></app-snow>
<div *ngIf="updateAvailable" class="d-flex align-items-center alert bg-warning border-0 m-0" role="alert">
  <div class="text-white">
    <span>Uma nova versão já está disponível!</span>
    <button class="btn btn-warning text-white ml-4" (click)="refresh()">
      <i class="fad fa-sync"></i>&nbsp;&nbsp;Atualizar
    </button>
  </div>
</div>
<div class="page-container overflow-hidden h-100" id="full-window">
  <router-outlet></router-outlet>
</div>
